import { render, staticRenderFns } from "./AppointmentDeposit.vue?vue&type=template&id=fd685880"
import script from "./AppointmentDeposit.vue?vue&type=script&lang=js"
export * from "./AppointmentDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports